<template>
    <div class="cc-voucher">
        <div class="cc-voucher__title cc-title cc-title--voucher">{{ title }}</div>
        <div class="cc-voucher__remove-voucher cc-control cc-control--remove-voucher" @click="removeVoucher">&times;</div>
        <div class="cc-voucher__price cc-price cc-price--voucher">{{ voucher.value }}</div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            title: function () {
                if (this.voucher.name) {
                    return this.voucher.name;
                }

                return this.voucher.code;
            },
        },
        methods: {
            removeVoucher: function () {
                this.$store.dispatch('voucher/remove', this.voucher.code);
            },
        },
        props: [
            'voucher',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/voucher";
</style>
